import React from 'react';
import styled from 'styled-components';
import { type HomePageProps, ManagementCard } from '.';

import { HOME_PAGE_TEXT } from './lang';

export const HomePage: React.FunctionComponent<HomePageProps> = (
  props: HomePageProps,
) => {
  const { managementCards } = props;
  return (
    <Container>
      <h1>{HOME_PAGE_TEXT.HOME_PAGE}</h1>
      <div className="management-cards-area">
        {managementCards.map((card, index) => {
          return (
            <ManagementCard
              key={index}
              title={card.title}
              caseField={card.caseField}
              caseName={card.caseName}
              caseNumber={card.caseNumber}
              backgroundColor={card.backgroundColor}
              navLink={card.navLink}
            />
          );
        })}
      </div>
    </Container>
  );
};

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;

  h1 {
    color: #951d1d;
    font-size: 2rem;
    font-weight: 500;
    margin: 1rem;
  }

  .management-cards-area {
    width: 100%;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: flex-start;
    padding: 0 2rem;
  }
`;
